import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBath = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1 7.1) scale(0.1294)",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "11.6px"
		},
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 168,
			height: 73,
			rx: 8
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 28,
			cy: 37.5,
			r: 12
		})]
	})
});
export default SvgBath;
